import '../css/main.scss';

// Our modules / classes

// Instantiate a new object using our modules/classes

// mobile nav menu

const headerMobileNavToggle = document.querySelector(
  '.header-mobilenav__toggle'
);
const headerNavMenu = document.querySelector('.header-nav__menu');
const hamburger = document.querySelector('.hamburger');
const headerMobileNav = document.querySelector('.header-mobilenav');
const headerMobileNavItem = document.querySelectorAll('.nav-menu__item');

headerMobileNavToggle.addEventListener('click', () => {
  headerNavMenu.classList.toggle('mobilenav');
  document.body.classList.toggle('overflow-hide');
  hamburger.classList.toggle('.back-black');
  headerMobileNav.classList.toggle('header-mobilenav--active');
});

headerMobileNavItem.forEach((el) => {
  el.addEventListener('click', () => {
    if (document.documentElement.clientWidth <= 1024) {
      headerNavMenu.classList.toggle('mobilenav');
      document.body.classList.toggle('overflow-hide');
      hamburger.classList.toggle('.back-black');
      headerMobileNav.classList.toggle('header-mobilenav--active');
    }
  });
});

// close mobile menu if window resized to larger screen size

window.addEventListener('resize', closeMobileMenu);

function closeMobileMenu() {
  if (document.documentElement.clientWidth > 1024) {
    headerNavMenu.classList.remove('mobilenav');
    document.body.classList.remove('overflow-hide');
    hamburger.classList.remove('.back-black');
    headerMobileNav.classList.remove('header-mobilenav--active');
  }
}

// year in footer
let today = new Date();
today = today.getFullYear();

document.querySelector('#year').textContent = today;

// add in close nav when using back or forward

// observer tracking
/*
const hidingObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    console.log(entry);
    if (entry.isIntersecting) {
      entry.target.classList.add('showleft');
    }
    // uncomment to run animation multiple times
    /* else {
      entry.target.classList.remove('show');
    }
  });
});

const hiddenElements = document.querySelectorAll('.hiddenleft');
hiddenElements.forEach((el) => hidingObserver.observe(el));
*/
